import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GATrackingEventType } from '~shared/modules/ga-tracking/constants';
import { Ga4TrackingHelpersService } from '~shared/modules/ga-tracking/utils';
import { Product } from '~shared/models';
import { PriceTypes } from '~shared/modules/price-type-toggler/price-type-toggler.module';

export class GaTrackingSelectPromotionEventModel {
  constructor(
    private pageName: string,
    private product: Product,
    private priceType: PriceTypes,
    private productIndex: number,
    private creative_name?: string,
    private searchTerm?: string
  ) {}

  getEventType(): GATrackingEventType {
    return GATrackingEventType.SelectPromotion;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: this.getEventType(),
      label: this.product.id,
      gtmCustom: {
        ecommerce: {
          item_list_name: this.pageName,
          creative_name: this.creative_name,
          search_term: this.searchTerm,
          items: [
            Ga4TrackingHelpersService.getGA4ItemObject(this.product, this.priceType, this.productIndex),
          ],
        },
      },
    };
  }
}
